import { render, staticRenderFns } from "./SectionContent.vue?vue&type=template&id=16f53e52&scoped=true&"
import script from "./SectionContent.vue?vue&type=script&lang=ts&"
export * from "./SectionContent.vue?vue&type=script&lang=ts&"
import style0 from "./SectionContent.vue?vue&type=style&index=0&id=16f53e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f53e52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VIcon,VImg})
